export const TIPO_ANULACION_RESCINDIR = 2

export const MAX_MOTIVO_ANULACION = 200

export const MOTIVO_ANULACION_POR_DEFECTO = {
  tipoAnulacion: TIPO_ANULACION_RESCINDIR,
  motivoAnulacion: 'Documento incorrecto',
}

export interface MotivoAnulacion {
  tipoAnulacion: number
  motivoAnulacion: string
}

export const motivoAnulacionEsValido = (motivo: MotivoAnulacion): boolean =>
  motivo.motivoAnulacion.trim().length > 0

interface Props {
  motivo: MotivoAnulacion
  onChange: (motivo: MotivoAnulacion) => void
}

const CamposMotivoAnulacion = ({motivo, onChange}: Props) => {
  const falta = !motivoAnulacionEsValido(motivo)

  return (
    <div className='label-input'>
      <label className='field-label m'>
        Motivo de la invalidación <span style={{color: '#f71d1d'}}>*</span>
      </label>
      <textarea
        value={motivo.motivoAnulacion}
        onChange={(e) => onChange({...motivo, motivoAnulacion: e.target.value})}
        placeholder='Explique por qué se invalida el documento...'
        maxLength={MAX_MOTIVO_ANULACION}
        rows={3}
        className='m text-field w-input'
        style={{
          height: 'auto',
          minHeight: '72px',
          resize: 'vertical',
          paddingTop: '12px',
          lineHeight: '1.5',
        }}
      />
      <p
        style={{
          fontSize: '11px',
          color: falta ? 'rgba(247, 29, 29, 0.978)' : 'rgba(27, 27, 27, 0.4)',
          textAlign: 'right',
          marginTop: '4px',
        }}
      >
        {falta
          ? 'Escriba el motivo para continuar'
          : `${MAX_MOTIVO_ANULACION - motivo.motivoAnulacion.length} caracteres disponibles`}
      </p>
    </div>
  )
}

export default CamposMotivoAnulacion
